export default __webpack_public_path__ + "static/fahad-bin-kamal-anik-jNS7kDxkIyQ-unsplash-8b00d28ee060ee9816bb86863c03e743.jpg";